export default "__VITE_ASSET__CZImcW3H__"